var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTourIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_signpost",
    "data-name": "vuesax/linear/signpost",
    transform: "translate(-300 -700)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signpost"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2,0H3.94A1.781,1.781,0,0,0,2.85.38L.66,2.13a1.742,1.742,0,0,0,0,2.73L2.85,6.61a1.742,1.742,0,0,0,1.09.38H12.2a1.746,1.746,0,0,0,1.75-1.75V1.74A1.743,1.743,0,0,0,12.2,0Z",
    transform: "translate(305.02 702)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.75,0h8.26A1.781,1.781,0,0,1,11.1.38l2.19,1.75a1.742,1.742,0,0,1,0,2.73L11.1,6.61a1.742,1.742,0,0,1-1.09.38H1.75A1.746,1.746,0,0,1,0,5.24V1.74A1.743,1.743,0,0,1,1.75,0Z",
    transform: "translate(305.05 712)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,3V0",
    transform: "translate(312 709)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,3V0",
    transform: "translate(312 719)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H6",
    transform: "translate(309 722)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(300 700)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIcon);
export default __webpack_public_path__ + "static/media/tourIcon.11f7e316662f254a0277c5e40a31ca10.svg";
export { ForwardRef as ReactComponent };